export default {"src":"/_next/static/media/lawn-installation-turf.68d2b513.svg","height":41,"width":41,"blurWidth":0,"blurHeight":0};